import { render, staticRenderFns } from "./brand_slider.schema.vue?vue&type=template&id=7ddc6f4d&"
import script from "./brand_slider.schema.vue?vue&type=script&lang=js&"
export * from "./brand_slider.schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports